import IconTiktok from "@icons/dark/tiktok.svg?react";
import type { LinkedAccountPlatform } from "@store/linkedAccountSlice";
import { TIKTOK_PLATFORM } from "@store/linkedAccountSlice";
import type { ComponentType, SVGProps } from "react";

export interface PlatformFeatures {
  cornerBadge: boolean;
  regionFlag: boolean;
  accountTypeSubtitle: boolean;
}

export interface PlatformConfig {
  label: string;
  Icon: ComponentType<SVGProps<SVGSVGElement>>;
  supported: boolean;
  features: PlatformFeatures;
}

const TIKTOK_CONFIG: PlatformConfig = {
  label: "TikTok",
  Icon: IconTiktok,
  supported: true,
  features: {
    cornerBadge: true,
    regionFlag: true,
    accountTypeSubtitle: true,
  },
};

const PLATFORM_CONFIGS: Partial<Record<LinkedAccountPlatform, PlatformConfig>> = {
  [TIKTOK_PLATFORM]: TIKTOK_CONFIG,
};

const FALLBACK_CONFIG: PlatformConfig = {
  label: "Unknown",
  Icon: IconTiktok,
  supported: false,
  features: {
    cornerBadge: false,
    regionFlag: false,
    accountTypeSubtitle: false,
  },
};

export const getPlatformConfig = (platform: LinkedAccountPlatform): PlatformConfig => {
  return PLATFORM_CONFIGS[platform] ?? { ...FALLBACK_CONFIG, label: platform };
};

export const isPlatformSupported = (platform: LinkedAccountPlatform): boolean => {
  return getPlatformConfig(platform).supported;
};

export const getSupportedPlatforms = (): LinkedAccountPlatform[] =>
  (Object.keys(PLATFORM_CONFIGS) as LinkedAccountPlatform[]).filter(
    (platform) => PLATFORM_CONFIGS[platform]?.supported,
  );
